'use client';

import styled from 'styled-components';

const NoticeContainer = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 60px;
  gap: 5px;
  align-items: center;
  height: 100%;

  &:hover {
    cursor: pointer;
    background-color: #f5f5f5;
    transition: background-color 0.3s;
  }
`;

const CategoryCell = styled.div`
  color: #8424ea;
  text-align: center;
  font-weight: 500;
  width: 60px;
  font-size: 12px;
`;

const SubjectCell = styled.div`
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
`;

const DateCell = styled.div`
  color: #b2b2b2;
  width: 60px;
  font-size: 12px;
`;

const NoticeSlideItemStyled = {
  NoticeContainer,
  CategoryCell,
  SubjectCell,
  DateCell,
};

export default NoticeSlideItemStyled;
